var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteDialogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 42C6.5 22.1178 22.6178 6 42.5 6C62.3823 6 78.5 22.1178 78.5 42C78.5 61.8823 62.3823 78 42.5 78C22.6178 78 6.5 61.8823 6.5 42Z",
    fill: "#F8C9D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 42C6.5 22.1178 22.6178 6 42.5 6C62.3823 6 78.5 22.1178 78.5 42C78.5 61.8823 62.3823 78 42.5 78C22.6178 78 6.5 61.8823 6.5 42Z",
    stroke: "#FDEDF0",
    strokeWidth: 12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 34.8H55V37.2H52.6V52.8C52.6 53.1183 52.4736 53.4235 52.2485 53.6485C52.0235 53.8736 51.7183 54 51.4 54H34.6C34.2817 54 33.9765 53.8736 33.7515 53.6485C33.5264 53.4235 33.4 53.1183 33.4 52.8V37.2H31V34.8H37V31.2C37 30.8817 37.1264 30.5765 37.3515 30.3515C37.5765 30.1264 37.8817 30 38.2 30H47.8C48.1183 30 48.4235 30.1264 48.6485 30.3515C48.8736 30.5765 49 30.8817 49 31.2V34.8ZM50.2 37.2H35.8V51.6H50.2V37.2ZM39.4 40.8H41.8V48H39.4V40.8ZM44.2 40.8H46.6V48H44.2V40.8ZM39.4 32.4V34.8H46.6V32.4H39.4Z",
    fill: "#DF1C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDialogIcon);
export default __webpack_public_path__ + "static/media/delete-dialog-icon.09ea70363894e6bf35a4337ba69e0391.svg";
export { ForwardRef as ReactComponent };